import styled, { css } from 'styled-components';
import { media, layout } from 'src/components/base';

const searchHeight = layout.searchBar.height.desktop.value;
const searchHeightMobile = layout.searchBar.height.mobile.value;
const searchBorderWidth = layout.searchBar.borderWidth;
const boxShadowStyle = '0px 6px 10px 0px rgba(0, 0, 0, 0.2)';

type SearchInputProps = {
  searchIsOpen: boolean;
};

export const SearchInput = styled.div<SearchInputProps>(
  props => css`
    width: 100%;
    border: ${layout.searchBar.borderWidth}px solid
      ${p => p.theme.colors.maybeBlue700};
    overflow: hidden;
    border-bottom: ${layout.searchBar.borderWidth}px solid
      ${p => p.theme.colors.maybeBlue700};
    border-radius: 5px;

    ${props.searchIsOpen &&
    css`
      border-bottom: none;
      border-radius: 5px 5px 0px 0px;
    `}
  `
);

type SearchResultProps = {
  showFloatingResult: boolean;
  searchIsOpen: boolean;
  showNewComparePageLayout: boolean;
};

export const SearchResult = styled.div<SearchResultProps>(
  props => css`
    position: relative;
    background: ${props.theme.colors.base0};
    border-radius: 0px 0px 5px 5px;
    overflow: hidden;
    text-align: left;

    ${props.showFloatingResult &&
    css`
      position: absolute;
      left: 0;
      right: 0;
      border: none;
      border-top: none;
      z-index: 10;
      box-shadow: ${boxShadowStyle};

      ${props.searchIsOpen &&
      css`
        border: 1px solid ${props.theme.colors.maybeBlue700};
        border-top: none;
      `}

      ${media.smallOnly`
          top: ${
            props.showNewComparePageLayout
              ? `${searchHeightMobile + searchBorderWidth * 2}px`
              : `${searchHeightMobile}px`
          };
        `};

      ${media.mediumOnly`
          top: ${searchHeight + searchBorderWidth * 2}px;
        `};

      ${media.largeUp`
          top: ${searchHeight}px;
        `};
    `};

    .pj-ui-search--products {
      padding-top: 0;
    }

    ${media.mediumDown`
      padding: 0 ${layout.measurements.spacing100};
    `};
  `
);

export const SearchWrapper = styled.div`
  width: 100%;
`;

type SearchProps = {
  showNewComparePageLayout: boolean;
};

export const Search = styled.div<SearchProps>(
  props => css`
    width: 100%;

    ${props.showNewComparePageLayout &&
    css`
      ${media.mediumDown`
          padding: 0 ${layout.measurements.spacing100};

          ${SearchInput} {
            border-bottom: 1px solid ${props.theme.colors.maybeBlue700};
            border-radius: 5px;
          }

          ${SearchResult} {
            border: none;
            box-shadow: none;
          }
        `}
    `}
  `
);
